import React from 'react';
import { FaUsers, FaCalendarAlt, FaBullhorn, FaExclamationTriangle } from 'react-icons/fa';
import { BsFileEarmarkArrowDownFill, BsLink45Deg } from 'react-icons/bs';
import { getButtonConfigFromBackend } from '../utils/bancaButtonConfigUtils';
import ActionButton from './ActionButton';

interface BancaActionsProps {
  banca?: any;
  onComposicaoClick?: (banca: any) => void;
  onDataClick?: (banca: any) => void;
  onConvocarClick?: (banca: any) => void;
  onSalaClick?: (banca: any) => void;
  onEmergenciaClick?: (banca: any) => void;
  onAtaClick?: (banca: any) => void;
}

const BancaActions: React.FC<BancaActionsProps> = ({ banca, onComposicaoClick, onDataClick, onConvocarClick, onSalaClick, onEmergenciaClick, onAtaClick }) => {
  const salaConfig = getButtonConfigFromBackend(banca, 'sala');
  const dataConfig = getButtonConfigFromBackend(banca, 'data');
  const composicaoConfig = getButtonConfigFromBackend(banca, 'composicao');
  const convocarConfig = getButtonConfigFromBackend(banca, 'convocar');
  const emergenciaConfig = getButtonConfigFromBackend(banca, 'emergencia');
  const ataConfig = getButtonConfigFromBackend(banca, 'ata');
  
  return (
    <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'nowrap', minWidth: 'max-content' }}>
      <ActionButton 
        config={salaConfig} 
        onClick={() => onSalaClick?.(banca)}
        customIcon={<BsLink45Deg />}
        customTitle="Definir Sala da Banca - Link da sala virtual ou local presencial"
      />
      <ActionButton 
        config={dataConfig} 
        onClick={() => onDataClick?.(banca)}
        customIcon={<FaCalendarAlt />}
        customTitle="Definir Data da Banca - Data e horário de início e fim"
      />
      <ActionButton 
        config={composicaoConfig} 
        onClick={() => onComposicaoClick?.(banca)}
        customIcon={<FaUsers />}
        customTitle="Composição da Banca - Definir membros titulares, suplentes e técnicos"
      />
      <ActionButton 
        config={convocarConfig} 
        onClick={() => onConvocarClick?.(banca)}
        customIcon={<FaBullhorn />}
        customTitle="Convocar Banca - Envia email de convocação para todos os membros definidos"
      />
      <ActionButton 
        config={emergenciaConfig} 
        onClick={() => onEmergenciaClick?.(banca)}
        customIcon={<FaExclamationTriangle />}
        customTitle="Substituição de Emergência - Substituir um membro e notificar o novo por email"
      />
      <ActionButton 
        config={ataConfig} 
        onClick={() => onAtaClick?.(banca)}
        customIcon={<BsFileEarmarkArrowDownFill />}
      />
    </div>
  );
};

export default BancaActions;